import i18n from "@src/common/lib/i18n";
const DIC = {
  isIndoorList: [
    {
      label: "是",
      value: "1"
    },
    {
      label: "否",
      value: "0"
    }
  ],
  stateList: [
    {
      label: "在线",
      value: "1"
    },
    {
      label: "离线",
      value: "0"
    },
    {
      label: "故障",
      value: "2"
    }
  ],
  deviceType: [
    {
      label: "电气火灾监控设备",
      value: "21"
    }
  ],
  businessName: [
    {
      label: "深圳市中电电力厂商",
      value: "0"
    }
  ]
};
export const tableOption = function (deviceShow, areaShow) {
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    emptyText: i18n.t("cameraList.title.noData"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: "：",
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: "120px",
    dialogWidth: "700px",
    menuBtn: false,
    column: [
      {
        label: "设备名称",
        prop: "deviceName",
        labelWidth: 100,
        search: true,
        span: 12,
        clearable: true,
        overHidden: true,
        rules: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "change"
          },
          {
            min: 1,
            max: 64,
            message: "长度小于64个字符",
            trigger: "change"
          }
        ]
      },
      {
        label: "设备IP",
        //search: true,
        prop: "ip",
        labelWidth: 110,
        overHidden: true,
        span: 12,
        rules: [
          {
            required: true,
            message: "请输入设备IP",
            trigger: "blur"
          }
        ]
      },
      // {
      //   label: "systemId",
      //   //search: true,
      //   prop: 'systemId',
      //   labelWidth: 110,
      //   overHidden: true,
      //  // hide: true,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   addDisplay: false,
      //   span: 8,
      // },
      {
        label: "设备id",
        search: true,
        prop: "thirdDeviceId",
        labelWidth: 110,
        span: 12,
        rules: [
          {
            required: true,
            message: "请输入设备id",
            trigger: "blur"
          }
        ]
      },
      {
        label: "设备端口",
        prop: "port",
        labelWidth: 110,
        span: 12,
        overHidden: true,
        placeholder: "请输入设备端口 ",
        rules: [
          {
            required: true,
            message: "请输入设备端口",
            trigger: "blur"
          }
        ]
      },
      // 以及属性 可改
      // {
      //   label: "厂商名称",
      //   prop: "factoryName",
      //   labelWidth: 100,
      //   span: 24,
      //   hide: true,
      //   overHidden: true
      // },
      {
        label: "从机地址",
        prop: "slaveId",
        labelWidth: 110,
        overHidden: true,
        span: 12,
        placeholder: "请输入从机地址 ",
        rules: [
          {
            required: true,
            message: "请输入从机地址",
            trigger: "blur"
          }
        ]
      },
      {
        label: "主设备类型",
        prop: "deviceType",
        labelWidth: 110,
        overHidden: true,
        span: 12,
        type: "select",
        dicData: DIC.deviceType,
        rules: [
          {
            required: true,
            message: "请输入主设备类型",
            trigger: "change"
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 21 ? "电气火灾监控设备" : "";
          
        }
      },
      {
        span: 12,
        label: "设备组",
        labelWidth: 110,
        prop: "deviceWorkGroupName",
        overHidden: true,
        disabled: true,
      },
      {
        span: 12,
        labelWidth: 110,
        label: "区域",
        prop: "areaName",
        overHidden: true,
        disabled: true,
      },
      {
        label: "设备状态",
        prop: "status",
        type: "select",
        editDisplay: false,
        viewDisplay: true,
        addDisplay: false,
        disabled: true,
        span: 12,
        search: true,
        labelWidth: 100,
        clearable: true,
        dicData: DIC.stateList,
        formatter: function (row, value) {
          let str = "";
          if (value == 1) {
            str = "在线";
          } else if (value == 2) {
            str = "故障";
          } else {
            str = "离线";
          }
          return str;
        },
      },
      // {
      //   label: "是否在室内",
      //   prop: "isIndoor",
      //   type: "select",
      //   //display:false,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   addDisplay: true,
      //   span: 12,
      //   formslot: true,
      //   // search: true,
      //   labelWidth: 100,
      //   dicData: DIC.isIndoorList,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请选择",
      //       trigger: "blur"
      //     }
      //   ],
      //   mock: {
      //     type: "dic"
      //   },
      //   formatter: function (row, value) {
      //     return Number(value) === 1 ? "室内" : "室外";
      //   },
      //   viewFormatter: (row, value) => {
      //     return Number(value) === 1 ? "室内" : "室外";
      //   }
      // },
      {
        label: "所属楼栋",
        prop: "buildName",
        labelWidth: 100,
        span: 12,
        // search: true,
        overHidden: true,
        viewDisplay: true,
        editDisplay: true,
        formslot: true,
        // rules: [
        //   {
        //     required: true,
        //     message: "请标记室内位置",
        //     trigger: "blur"
        //   }
        // ]
      },
      {
        label: "所属楼层",
        prop: "floorName",
        labelWidth: 100,
        span: 12,
        formslot: true,
      },
      // {
      //   label: "高度",
      //   prop: "height",
      //   labelWidth: 100,
      //   hide: true,
      //   disabled: true,
      //   viewDisplay: true,
      //   // placeholder: ' ',
      //   span: 12,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请输入高度",
      //       trigger: "blur"
      //     }
      //   ]
      // },
      // {
      //   label: "宽度",
      //   prop: "width",
      //   hide: true,
      //   viewDisplay: true,
      //   labelWidth: 100,
      //   disabled: true,
      //   // placeholder: '',
      //   span: 12,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请输入宽度",
      //       trigger: "blur"
      //     }
      //   ]
      // },
      // {
      //   label: "经度",
      //   viewDisplay: true,
      //   prop: "longitude",
      //   labelWidth: 100,
      //   formslot: true,
      //   span: 12,
      //   // clearable: true,
      //   hide: true,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请输入经度",
      //       trigger: "change"
      //     },
      //     {
      //       pattern:
      //         /^[-+]?(0?\d{1,2}|0?\d{1,2}\.\d{1,10}|1[0-7]?\d{1}|1[0-7]?\d{1}\.\d{1,10}|180|180\.0{1,10})$/,
      //       message: "请输入-180~180之间,小数点最大保留10位",
      //       trigger: "change"
      //     }
      //   ]
      // },
      // {
      //   label: "纬度",
      //   prop: "latitude",
      //   labelWidth: 100,
      //   formslot: true,
      //   hide: true,
      //   span: 12,
      //   // clearable: true,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请输入纬度",
      //       trigger: "change"
      //     },
      //     {
      //       pattern:
      //         /^[-+]?([0-8]?\d{1}|[0-8]?\d{1}\.\d{1,10}|90|90\.0{1,10})$/,
      //       message: "请输入-90~90之间，小数点最大保留10位",
      //       trigger: "change"
      //     }
      //   ]
      // },
      // {
      //   label: "横坐标",
      //   prop: "abscissa",
      //   labelWidth: 100,
      //   hide: true,
      //   disabled: true,
      //   // placeholder: ' ',
      //   span: 12,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请输入横坐标",
      //       trigger: "blur"
      //     }
      //   ]
      // },
      // {
      //   label: "纵坐标",
      //   prop: "ordinate",
      //   hide: true,
      //   labelWidth: 100,
      //   disabled: true,
      //   // placeholder: '',
      //   span: 12,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请输入纵坐标",
      //       trigger: "blur"
      //     }
      //   ]
      // },

      {
        label: "设备描述",
        type: "textarea",
        prop: "thirdDeviceDesc",
        labelWidth: 100,
        minRows: 5,
        maxlength: 120,
        span: 24,
        clearable: true
      }
    ]
  };
};
